<template>
  <b-row>
    <b-col>
      <b-form-group>
        <label for="" style="font-size: small;" class="mb-1">
          ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
        </label>
        
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="sintomasOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => sintomasVSelect = onAddNewOpt(newArray)"
        />
      </b-form-group>

      <b-card
        v-for="( sintoma ) in preguntas.sintomas"
        :key="sintoma.value"
        class="mb-2"
        style="border:1px solid #c9c9c9;"
      >
        <b-row>
          <b-col>
            <h6>{{ sintoma.text }}</h6>
          </b-col>
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-3">Comienzo</label>

          <b-form-input 
            class="col-2 ml-1"
            type="number"
            min="0"
            max="99"
            v-model="sintoma.comienzoNumero"
            placeholder="0"
          />

          <v-select
            class="col-4"
            placeholder="Desde cuando"
            :options="tipoTiempoOpts"
            :reduce="option => option"
            label="text"
            v-model="sintoma.comienzoTipo"
          />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-3">Posibles causas</label>
          <v-select
            class="col-8"
            placeholder="Elija una o mas opciones"
            :options="factoresOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => sintoma.factores = onAddNewOpt(newArray)"
          />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-3">Tratamientos</label>
          <v-select
            class="col-8"
            placeholder="Elija una o mas opciones"
            :options="tratamientosOpts"
            :reduce="option => option"
            label="text"
            :multiple="true"
            taggable
            @input="newArray => sintoma.tratamientos = onAddNewOpt(newArray)"
          />
        </b-row>
        
      </b-card>

      <div>
        <b-form-checkbox
          v-model="preguntas.observaciones.active"
        >
          <label for="">Observaciones Adicionales:</label>
        </b-form-checkbox>

        <b-form-textarea
          v-if="preguntas.observaciones.active"
          v-model="preguntas.observaciones.text"
        />
      </div>

    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import { addNewOpt } from '@/shared/helpers';

export default {
  name: 'PreguntasFisiatria',

  components: {
    vSelect
  },

  data() {
    return {

      sintomasVSelect:[],

      preguntas:{
        sintomas:[],
        observaciones:{
          active:false,
          text:''
        },
        
      },

      sintomasOpts : [
        { value: "dolor_muscular",        text: "Dolor muscular" },
        { value: "dolor_arrticular",      text: "Dolor articular" },
        { value: "limitacion_movimiento", text: "Limitación de movimiento" },
        { value: "debilidad_muscular",    text: "Debilidad muscular" },
        { value: "entumecimiento",        text: "Entumecimiento u hormigueo" },
        { value: "inflamacion",           text: "Inflamación" },
        { value: "fatiga",                text: "Fatiga" },
        { value: "dificultad_caminar",    text: "Dificultad para caminar" },
        { value: "perdida_equilibrio",    text: "Pérdida de equilibrio" }
      ],

      tipoTiempoOpts:[
        { value: 'dias',    text: 'Dias' },
        { value: 'semanas', text: 'Semanas' },
        { value: 'meses',   text: 'Meses' },
        { value: 'anios',   text: 'Años' },
      ],

      factoresOpts : [
        { value: "lesionesPrevias",      text: "Lesiones previas" },
        { value: "cirugiasRecientes",    text: "Cirugías recientes" },
        { value: "enfermedadesCronicas", text: "Enfermedades crónicas" },
        { value: "actividadIntensa",     text: "Actividad física intensa" },
        { value: "sedentarismo",         text: "Sedentarismo" },
        { value: "edadAvanzada",         text: "Edad avanzada" }
      ],

      tratamientosOpts: [
        { value: "analgesicos",          text: "Medicamentos analgésicos" },
        { value: "fisioterapia",         text: "Fisioterapia" },
        { value: "terapiaOcupacional",   text: "Terapia ocupacional" },
        { value: "ejercicioTerapeutico", text: "Ejercicio terapéutico" },
        { value: "cirugia",              text: "Cirugía" }
      ]

    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

  watch: {

    sintomasVSelect:{
      deep:true,
      handler( newArray ){
        const idSintomas = this.sintomasVSelect.map( item => item.value );

        this.preguntas.sintomas = this.preguntas.sintomas.filter(
          item => idSintomas.includes(item.value)
        );

        idSintomas.forEach( id => {
          if( !this.preguntas.sintomas.some( item => item.value === id )){
            const newItem = newArray.find( item => item.value === id );

            this.preguntas.sintomas.push({
              id: newItem.id || null,
              value: newItem.value,
              text: newItem.text,
              comienzoTipo: null,
              comienzoNumero: null,
              factores:[],
              tratamientos:[]
            });
          }
        });
      }
    },

    preguntas: {
      deep: true,
      handler(newValue){
        this.$store.commit("setFisiatriaPreguntas", newValue);
      }
    }
  },
}
</script>
